<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Medication</h2>
        <hr />
        <form @submit.prevent="handleSubmit">
            <label>Name</label>
            <input v-model="form.name" class="form-control" required />
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <label>Symptom Treated</label>
            <input v-model="form.symptom_treated" class="form-control" required />
            <div v-if="errors.symptom_treated" class="error-message">{{ errors.symptom_treated[0] }}</div>

            <label>Frequency & Dosage</label>
            <textarea v-model="form.frequency_dosage" class="form-control" rows="3" required></textarea>
            <div v-if="errors.frequency_dosage" class="error-message">{{ errors.frequency_dosage[0] }}</div>

            <div class="mt-3">
                <button class="btn btn-success btn-sm">💾 Save</button>
                <button class="btn btn-secondary btn-sm ms-2"
                    @click="$router.push('/dashboard/medications')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            isEditing: false,
            form: {
                name: '',
                symptom_treated: '',
                frequency_dosage: ''
            },
            errors: {},
            errorMessage: ''
        };
    },
    methods: {
        async handleSubmit() {
            this.errors = {};
            this.errorMessage = '';

            try {
                if (this.isEditing) {
                    await this.$api.put(`/medications/${this.id}`, this.form);
                } else {
                    await this.$api.post('/medications', this.form);
                }
                this.$router.push('/dashboard/medications');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred. Please try again.';
                }
            }
        }
    },
    async mounted() {
        if (this.id) {
            this.isEditing = true;
            const res = await this.$api.get(`/medications/${this.id}`);
            this.form = res.data;
        }
    },

};
</script>